import React from 'react'

import Method from "./Method"
import { methods } from "../data"

export default function Methods() {
  
  return (
    <div id="method">
      <h2 className="title txs">
        Notre méthodologie
      </h2>
      <div className="sub_title">
        Découvrez si notre méthode peut être adaptée à vous et à vos objectifs
      </div>
      <div className="method_container">
        {methods.map(method => (
          <Method method={method} key={Math.random()} />
        ))}
      </div>
    </div>
  )
}
